import React, { Component } from 'react';
import {
  ActivityIndicator,
  Alert,
  Clipboard,
  Dimensions,
  Image,
  InteractionManager,
  Linking,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import { connect } from 'react-redux';
import _ from 'lodash';

import { KeyboardAwareScrollView, Toast, ToastDuration } from '../modules';
import Constants from '../utils/Constants';
import Utils from '../utils/Utils';
import UserUtils from '../utils/UserUtils';
import APIClient from '../utils/APIClient';
import LoadingIndicator from '../common/LoadingIndicator';
import AlertUtils from '../utils/AlertUtils';
import PhoneUtils from '../utils/PhoneUtils';
import DeviceUtils from '../utils/DeviceUtils';

const contentWidth = Math.min(Dimensions.get('window').width - 40, 300);
const TOAST_REF = 'toast';

class OrderScreen extends Component {

  static navigationOptions = ({navigation}) => {
    const {params} = navigation.state;
    return {
      headerBackTitle: null,
      headerTitle: 'Chi tiết đơn hàng',
    };
  };

  constructor (props) {
    super(props);

    this.state = {
      loading: false,
      canEdit: false,
      logs: [],
      log: '',
    };

    let id;
    if (Platform.OS === 'web') {
      id = this.props.match.params.id;
    } else {
      const {params} = this.props.navigation.state;
      id = params ? (params.data ? params.data.id : params.id) : null;
    }
    this._id = id;
  }

  componentDidMount () {
    if (Platform.OS === 'web') {
      this._loadData();
    } else {
      const {params} = this.props.navigation.state;
      if (params && params.data) {
        this._updateData(params.data);
      } else {
        InteractionManager.runAfterInteractions(() => {
          this._loadOrder();
        });
      }
      InteractionManager.runAfterInteractions(() => {
        this._loadLogs();
      });
    }
  }

  componentWillUnmount () {
  }

  _updateInputValue = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  _loadData = () => {
    this._loadOrder();
    this._loadLogs();
  };

  _loadOrder = async () => {
    const {loading} = this.state;
    if (loading) {
      return;
    }

    this.setState({
      loading: true,
    });

    const path = `/order/${this._id}`;
    const {response, error} = await APIClient.GET(path);
    this._handleNetworkResponse(response, error);
  };

  _handleNetworkResponse = (response, error) => {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    if (response && response.response) {
      this._updateData(response.response);
    } else {
      const message = 'Có lỗi xảy ra, vui lòng thử lại sau';
      AlertUtils.alert({message});
    }
    this.setState({
      loading: false,
    });
  };

  _updateData = (data) => {
    const {user} = this.props;
    const {order, customer, seller} = data;
    const items = [];
    items.push({
      title: 'Đơn hàng',
      section: true,
    });
    items.push({
      title: 'ID',
      value: order.id,
    });
    if (order.purchase) {
      items.push({
        title: 'Gói mua',
        value: order.purchase.title.vi,
      });
      items.push({
        title: 'Giá gói',
        value: Utils.priceToString(order.purchase.oldPrice),
      });
    } else {
      items.push({
        title: 'Gói mua',
        value: order.purchaseId,
      });
    }
    items.push({
      title: 'Giá đơn hàng (đã giảm giá)',
      value: Utils.priceToString(order.price),
    });
    items.push({
      title: 'Phí vận chuyển',
      value: Utils.priceToString(order.fee),
    });
    items.push({
      title: 'Phương thức thanh toán',
      value: Constants.PAYMENT_METHOD_LOOKUP.get(order.paymentMethod),
    });
    if (!_.isEmpty(order.activateCode)) {
      items.push({
        title: 'Mã kích hoạt',
        value: order.activateCode,
        type: 'activateCode',
        selectable: Platform.OS !== 'web',
      });
    }
    if (!_.isEmpty(order.shippingCode)) {
      items.push({
        title: 'Mã vận đơn',
        value: order.shippingCode,
        type: 'shippingCode',
        selectable: Platform.OS !== 'web',
      });
    }
    items.push({
      title: 'Trạng thái',
      value: Constants.STATUS_LOOKUP.get(order.status),
    });

    if (UserUtils.isAdmin(user)) {
      items.push({
        title: 'Hoa hồng',
        value: Utils.priceToString(order.totalCommission),
      });
    } else {
      items.push({
        title: 'Hoa hồng',
        value: Utils.priceToString(order.commission),
      });
    }
    items.push({
      title: 'Ngày đăng kí',
      value: order.createdAt > 0 ? Utils.dateToString(order.createdAt) : 'N/A',
    });
    items.push({
      title: 'Ngày thanh toán',
      value: order.paidAt > 0 ? Utils.dateToString(order.paidAt) : 'N/A',
    });
    if (UserUtils.isAdmin(user)) {
      items.push({
        title: 'Ngày hết hạn',
        value: order.expiresAt ? Utils.dateToString(order.expiresAt) : '',
      });
    }

    const {devices} = order;
    if (UserUtils.isAdmin(user) && !_.isEmpty(devices)) {
      items.push({
        title: 'Danh sách thiết bị',
        section: true,
      });
      for (let i = 0; i < devices.length; i++) {
        const device = devices[i];
        const {id, active} = device;
        const title = DeviceUtils.findDeviceName(id);
        if (active) {
          items.push({
            title: title,
            value: 'Đang sử dụng',
            type: 'device',
            selectable: true,
            data: device,
          });
        } else {
          items.push({
            title: title,
            value: 'Không sử dụng',
          });
        }
      }
    }

    if (customer) {
      items.push({
        title: 'Người dùng',
        section: true,
      });
      items.push({
        title: 'ID',
        value: customer.id,
      });
      items.push({
        title: 'Họ và tên',
        value: customer.name ? customer.name : 'N/A',
      });
      items.push({
        title: 'Địa chỉ email',
        value: customer.email ? customer.email : 'N/A',
        type: 'email',
        selectable: !_.isEmpty(customer.email),
      });
      items.push({
        title: 'Nhà mạng',
        value: customer.phone ? PhoneUtils.findTelco(customer.phone) : 'N/A',
        type: 'telco',
      });
      items.push({
        title: 'Số điện thoại',
        value: customer.phone ? customer.phone : 'N/A',
        type: 'phone',
        selectable: !_.isEmpty(customer.phone),
      });
      items.push({
        title: 'Địa chỉ',
        value: !_.isEmpty(customer.address) ? customer.address : 'N/A',
      });
      items.push({
        title: 'Ngày đăng kí',
        value: customer.createdAt > 0
          ? Utils.dateToString(customer.createdAt)
          : 'N/A',
      });
    }

    if (seller) {
      items.push({
        title: 'Người bán',
        section: true,
      });
      items.push({
        title: 'ID',
        value: seller.id,
        type: seller.role,
        selectable: true,
      });
      items.push({
        title: 'Họ và tên',
        value: !_.isEmpty(seller.name) ? seller.name : 'N/A',
      });
      items.push({
        title: 'Địa chỉ email',
        value: !_.isEmpty(seller.email) ? seller.email : 'N/A',
      });
      items.push({
        title: 'Số điện thoại',
        value: !_.isEmpty(seller.phone) ? seller.phone : 'N/A',
      });
      items.push({
        title: 'Mã giảm giá',
        value: !_.isEmpty(seller.promoCode) ? seller.promoCode : 'N/A',
      });
      items.push({
        title: 'Giảm giá',
        value: seller.saleOff !== undefined ? seller.saleOff + '%' : 'N/A',
      });
    }

    const {paymentMethod, status} = order;
    const canEdit
      = UserUtils.isAdmin(user) && !_.isNil(data) && !_.isNil(order);
    const canAddLog
      = (UserUtils.isAdmin(user) || UserUtils.isSalesman(user)) &&
      !_.isNil(data) && !_.isNil(order);

    this.setState({
      data: data,
      items: items,
      canEdit: canEdit,
      canAddLog: canAddLog,
    });
  };

  _loadLogs = async () => {
    const {user} = this.props;
    const isSeller = UserUtils.isSeller(user);
    if (isSeller) {
      return;
    }

    if (_.isNil(this._id)) {
      return;
    }

    this.setState({
      logs: [
        {
          title: 'Lịch sử đơn hàng',
          section: true,
        },
      ],
    });

    const path = `/logs/order/${this._id}`;
    const {response, error} = await APIClient.GET(path);
    if (response) {
      console.log('order logs response: ', response);
    }
    if (error) {
      console.warn('order logs error: ', error);
    }
    if (_.isNil(response) || _.isEmpty(response.response)) {
      return;
    }

    let {logs} = this.state;
    for (let data of response.response) {
      const items = this._parseLog(data);
      logs = logs.concat(items);
    }
    this.setState({
      logs,
    });
  };

  _parseLog = (data) => {
    const items = [];
    const {username, content, updatedAt} = data;
    items.push({
      title: 'Người tạo',
      value: username,
    });
    items.push({
      title: 'Nội dung',
      value: content,
    });
    items.push({
      title: 'Thời gian',
      value: Utils.dateToString(updatedAt),
    });
    return items;
  };

  _renderItem = (item, index, dividerHidden) => {
    let {section, title, value, selectable} = item;
    selectable = selectable || Platform.OS !== 'web';
    return (
      <View
        key={index}
        style={[
          styles.item, {
            paddingTop: section ? 20 : 8,
            paddingBottom: section ? 0 : 8,
          }]}>
        <Text
          style={section ? styles.itemSectionText : styles.itemTitleText}>
          {title}
        </Text>
        {!section && <Text
          onPress={() => this._handleClickItem(item)}
          style={[
            styles.itemValueText, {
              color: selectable ? '#0000ff' : '#6b7adc',
              textDecorationLine: selectable ? 'underline' : 'none',
            }]}>
          {value}
        </Text>}
        {!section && !dividerHidden && <View
          style={styles.itemDivider}/>}
      </View>
    );
  };

  _handleClickItem = (item) => {
    const {title, type, value, data} = item;
    if (type === 'agency') {
      this._openAgency(value);
    } else if (type === 'partner') {
      this._openPartner(value);
    } else if (type === 'email') {
      if (Platform.OS === 'web') {
        const url = 'mailto:' + value;
        this._openUrl(url);
      } else {
        this._copyToClipboard(value);
      }
    } else if (type === 'phone') {
      if (Platform.OS === 'web') {
        const url = 'tel://' + value;
        this._openUrl(url);
      } else {
        this._copyToClipboard(value);
      }
    } else if (type === 'device') {
      this._deactiveDevice(title, data);
    } else if (type === 'shippingCode') {
      Linking.openURL('https://www.viettelpost.com.vn/Tracking?KEY=' + value);
    } else {
      this._copyToClipboard(value);
    }
  };

  _copyToClipboard = (value) => {
    if (Platform.OS === 'web') {
      return;
    }

    Clipboard.setString(value);
    const ref = this.refs[TOAST_REF];
    ref.show('Copied', ToastDuration.LENGTH_SHORT);
  };

  _openAgency = (id) => {
    if (Platform.OS === 'web') {
      const path = '/agency/' + id;
      this.props.history.push(path);
    } else {
      this.props.navigation.navigate('Agency', {
        id: id,
      });
    }
  };

  _openPartner = (id) => {
    if (Platform.OS === 'web') {
      const path = '/partner/' + id;
      this.props.history.push(path);
    } else {
      this.props.navigation.navigate('Partner', {
        id: id,
      });
    }
  };

  _openUrl (url) {
    console.log('open url: ' + url);
    Linking.openURL(url).catch(error => console.log('error: ', error));
  }

  /**
   * deactive device
   */
  _deactiveDevice = (title, data) => {
    const {id, active} = data;
    if (!active) {
      return;
    }

    const message = `Bạn có chắc là muốn bỏ kích hoạt trên máy "${title}" này`;
    const confirmed = AlertUtils.confirm({
      message,
      actions: [
        {text: 'Bỏ qua', style: 'cancel'},
        {text: 'Bỏ kích hoạt', onPress: () => this._doDeactiveDevice(data)},
      ],
    });
    if (confirmed) {
      this._doDeactiveDevice(data);
    }
  };

  _doDeactiveDevice = async (device) => {
    const {order} = this.state.data;
    const path = `/device/${order.id}/unlink/${device.id}`;
    const {response, error} = await APIClient.POST(path);
    this._handleDeactiveDeviceNetworkResponse(device, response, error);
  };

  _handleDeactiveDeviceNetworkResponse = (device, response, error) => {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    if (response && response.response && response.response.status) {
      // deactivate successfully
      let {items} = this.state;
      items = items.map(item => {
        if (item.type !== 'device' || item.data.id !== device.id) {
          return item;
        }
        return {
          title: item.title,
          value: 'Không sử dụng',
        };
      });
      this.setState({
        items: items,
      });
      this._loadLogs();
    } else {
      const message = error ? error.message : 'Bỏ kích hoạt không thành công';
      if (Platform.OS === 'web') {
        alert(message);
      } else {
        Alert.alert(
          global.__APP_NAME__,
          message,
        );
      }
    }
  };

  _edit = () => {
    if (Platform.OS === 'web') {
      return;
    }

    const {user} = this.props;
    if (!UserUtils.isAdmin(user)) {
      return;
    }

    const {editing} = this.state;
    if (editing) {
      return;
    }

    const actions = this._generateActions();
    actions.push({
      text: 'Bỏ qua',
      style: 'cancel',
    });

    Alert.alert(
      global.__APP_NAME__,
      'Chỉnh sửa đơn hàng',
      actions,
    );
  };

  _generateActions = () => {
    const {data} = this.state;
    if (!data) {
      return [];
    }
    const {order} = data;
    const {paymentMethod, status} = order;
    const {user} = this.props;

    const actions = [];

    const canEditOrder
      = (UserUtils.isAdmin(user) || UserUtils.isMarketer(user))
      && data && order
      &&
      (status === 'placed' || status === 'confirmed' || status === 'shipping');
    if (canEditOrder) {
      actions.push({
        action: 'editOrder',
        text: 'Chỉnh sửa đơn hàng',
        onPress: this._editOrder,
      });
    }

    const canConfirmOrder
      = UserUtils.isAdmin(user)
      && data && order
      && paymentMethod === 'cod'
      && status === 'placed';
    if (canConfirmOrder) {
      actions.push({
        action: 'confirm',
        text: 'Chốt đơn',
        onPress: () => this._makeAction({
          action: 'confirm',
          text: 'Chốt đơn hàng',
          message: 'Bạn thực sự có muốn chốt đơn hàng này?',
          success: 'Chốt đơn thành công',
          failure: 'Chốt đơn không thành công',
        }),
      });
    }

    const canActivateOrder
      = UserUtils.isAdmin(user)
      && data && order
      && ((paymentMethod === 'bank' && status === 'placed')
        || (paymentMethod === 'cod' && status === 'shipping'));
    if (canActivateOrder) {
      actions.push({
        action: 'activate',
        text: 'Kích hoạt đơn hàng',
        onPress: () => this._makeAction({
          action: 'activate',
          text: 'Kích hoạt đơn hàng',
          message: 'Bạn thực sự có muốn kích hoạt đơn hàng này?',
          success: 'Kích hoạt thành công',
          failure: 'Kích hoạt không thành công',
        }),
      });
      actions.push({
        action: 'give',
        text: 'Tặng quà',
        onPress: () => this._makeAction({
          action: 'give',
          text: 'Tặng quà',
          message: 'Bạn thực sự có muốn kích hoạt đơn hàng này như là quà tặng?',
          success: 'Tặng quà thành công',
          failure: 'Tặng quà không thành công',
        }),
      });
    }

    const canShip
      = UserUtils.isAdmin(user)
      && data && order
      && paymentMethod === 'cod'
      && (status === 'placed' || status === 'confirmed');
    if (canShip) {
      actions.push({
        action: 'ship',
        text: 'Sinh mã kích hoạt',
        onPress: () => this._makeAction({
          action: 'ship',
          text: 'Sinh mã kích hoạt',
          message: 'Bạn thực sự có muốn sinh mã kích hoạt cho đơn hàng COD này?',
          success: 'Sinh mã kích hoạt thành công',
          failure: 'Sinh mã kích hoạt không thành công',
        }),
      });
    }

    const canCancel
      = UserUtils.isAdmin(user)
      && data && order
      && (status === 'placed' || status === 'shipping');
    if (canCancel) {
      actions.push({
        action: 'cancel',
        text: 'Huỷ đơn hàng',
        onPress: () => this._makeAction({
          action: 'cancel',
          text: 'Huỷ đơn hàng',
          message: 'Bạn thực sự có muốn huỷ đơn hàng này?',
          success: 'Huỷ đơn hàng thành công',
          failure: 'Huỷ đơn hàng không thành công',
        }),
      });
    }

    const canRestore
      = UserUtils.isAdmin(user)
      && data && order
      && (status === 'cancel');
    if (canRestore) {
      actions.push({
        action: 'Khôi phục đơn hàng',
        onPress: () => this._makeAction({
          action: 'restore',
          message: 'Bạn thực sự có muốn khôi phục đơn hàng này?',
          success: 'Khôi phục đơn hàng thành công',
          failure: 'Khôi phục đơn hàng không thành công',
        }),
      });
    }

    const canSendEmail
      = UserUtils.isAdmin(user)
      && data && order
      && (status !== 'shipping' && status !== 'cancel');
    if (canSendEmail) {
      actions.push({
        action: 'sendEmail',
        text: 'Gửi lại email',
        onPress: () => this._makeAction({
          action: 'sendEmail',
          text: 'Gửi lại email',
          message: 'Bạn thực sự có muốn gửi lại email cho khách hàng?',
          success: 'Gửi email cho khách thành công',
          failure: 'Gửi email cho khách không thành công',
        }),
      });
    }

    return actions;
  };

  _editOrder = () => {
    const {data} = this.state;
    if (!data) {
      return [];
    }
    const {order} = data;
    if (Platform.OS === 'web') {
      const path = `/edit-order/${order.id}`;
      this.props.history.push(path);
    } else {
      this.props.navigation.push('EditOrder', {
        id: order.id,
      });
    }
  };

  _makeAction = (data) => {
    const {editing} = this.state;
    if (editing) {
      return;
    }

    const {text, message} = data;
    const confirm = AlertUtils.confirm({
      message,
      actions: [
        {text: 'Bỏ qua', style: 'cancel'},
        {text: text, onPress: () => this._doMakeAction(data)},
      ],
    });
    if (confirm) {
      this._doMakeAction(data);
    }
  };

  _doMakeAction = async (data) => {
    const {action, success, failure} = data;
    this.setState({
      editing: true,
      editingAction: action,
    });

    const path = `/order/${this._id}/${action}`;
    const {response, error} = await APIClient.POST(path);
    this._handleActionNetworkResponse(response, error, success, failure);
  };

  _handleActionNetworkResponse = (response, error, success, failure) => {
    /*if (response) {
      console.log('action response: ', response);
    }
    if (error) {
      console.error('action error: ', error);
    }*/

    if (response && response.response) {
      console.log('1');
      const order = response.response;
      if (!_.isEmpty(order) && order.id > 0) {
        let {data} = this.state;
        data = {
          ...data,
          order: order,
        };
        this._updateData(data);
        this._loadLogs();
      }

      AlertUtils.alert({
        message: success,
      });
    } else {
      const message = Utils.parseErrorMessage(response, error, failure);
      AlertUtils.alert({
        message,
      });
    }

    this.setState({
      editing: false,
      editingAction: '',
    });
  };

  _renderAction = (data, index) => {
    const {action, text, onPress} = data;
    const {editingAction} = this.state;
    return (
      <TouchableOpacity
        key={index}
        activeOpacity={0.75}
        onPress={onPress}
        style={styles.actionButton}>
        <Image
          source={require('../img/btn.png')}
          style={styles.actionButtonImage}/>
        <Text
          style={styles.actionButtonText}>
          {text}
        </Text>
        {action === editingAction && <View
          style={styles.actionActivity}>
          <ActivityIndicator
            animating
            color='#ffffff'
            style={styles.actionActivityIndicator}/>
        </View>}
      </TouchableOpacity>
    );
  };

  _addLog = async () => {
    const {logging} = this.state;
    if (logging) {
      return;
    }

    const {log} = this.state;
    if (_.isEmpty(log)) {
      AlertUtils.alert({
        message: 'Vui lòng điền ghi chú',
        actions: [
          {text: 'OK', onPress: () => this.refs['logTextInput'].focus()},
        ],
      });
      if (Platform.OS === 'web') {
        this.refs['logTextInput'].focus();
      }
      return;
    }

    const path = `/log/order/${this._id}`;
    const data = {
      content: log,
    };
    const {response, error} = await APIClient.POST(path, data);
    if (response) {
      console.log('add log response: ', response);
    }
    if (error) {
      console.log('add log error: ', error);
    }
    if (error || _.isNil(response) || _.isEmpty(response.response)) {
      const message = error ? error.message : 'Thêm ghi chú thất bại';
      AlertUtils.alert({message});
      return;
    }

    const items = this._parseLog(response.response);
    let {logs} = this.state;
    if (_.isEmpty(logs)) {
      logs = items;
    } else {
      logs.splice(1, 0, ...items);
      logs = logs.slice();
    }
    this.setState({
      logs,
      log: '',
    });
  };

  render () {
    const {loading, items, logs, log, canEdit, canAddLog, editing, logging} = this.state;
    let actions = [];
    if (Platform.OS === 'web') {
      actions = this._generateActions();
    }
    return (
      <View
        style={styles.container}>
        <KeyboardAwareScrollView
          automaticallyAdjustContentInsets={false}
          keyboardDismissMode={Platform.OS === 'ios' ? 'on-drag' : 'none'}
          keyboardShouldPersistTaps='always'
          style={styles.content}>
          {!_.isEmpty(items) && <View
            style={styles.contentContainer}>
            <View
              style={styles.info}>
              {items.map((item, index) => this._renderItem(item, index, true))}

              {Platform.OS === 'web' && canEdit && !_.isEmpty(actions)
              && <View
                style={styles.actionList}>
                {actions.map(this._renderAction)}
              </View>}
            </View>
            {!_.isEmpty(logs) && <View
              style={styles.logs}>
              {logs.map(
                (item, index) => this._renderItem(item, index, index % 3 !==
                  0))}
              {canAddLog && <View
                style={[
                  styles.input, {
                    width: null,
                    alignSelf: 'stretch',
                  }]}>
                <TextInput
                  ref='logTextInput'
                  value={log}
                  placeholder='Ghi chú'
                  placeholderTextColor='#51585ebf'
                  underlineColorAndroid='transparent'
                  clearButtonMode='while-editing'
                  autoCapitalize='none'
                  style={styles.textInput}
                  onChangeText={(text) => this._updateInputValue('log', text)}/>
              </View>}

              {canAddLog && <TouchableOpacity
                activeOpacity={0.75}
                onPress={this._addLog}
                style={[
                  styles.actionButton, {
                    alignSelf: 'center',
                  }]}>
                <Image
                  source={require('../img/btn.png')}
                  style={styles.actionButtonImage}/>
                <Text
                  style={styles.actionButtonText}>
                  THÊM GHI CHÚ
                </Text>
                {logging && <View
                  style={styles.actionActivity}>
                  <ActivityIndicator
                    animating
                    color='#ffffff'
                    style={styles.actionActivityIndicator}/>
                </View>}
              </TouchableOpacity>}
            </View>}
          </View>}
        </KeyboardAwareScrollView>

        {Platform.OS !== 'web' && canEdit && <TouchableOpacity
          activeOpacity={0.75}
          onPress={this._edit}
          style={[
            styles.actionButton, {
              marginTop: 20,
              marginBottom: 20,
              alignSelf: 'center',
            }]}>
          <Image
            source={require('../img/btn.png')}
            style={styles.actionButtonImage}/>
          <Text
            style={styles.actionButtonText}>
            CHỈNH SỬA ĐƠN HÀNG
          </Text>
          {editing && <View
            style={styles.actionActivity}>
            <ActivityIndicator
              animating={true}
              color='#ffffff'
              style={styles.actionActivityIndicator}/>
          </View>}
        </TouchableOpacity>}

        {loading && <LoadingIndicator/>}

        {Platform.OS !== 'web' && <Toast
          ref={TOAST_REF}
          position='center'/>}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f6efdb',
  },
  content: {
    flex: 1,
    backgroundColor: '#f6efdb',
  },
  contentContainer: {
    flex: 1,
    flexDirection: (Dimensions.get('window').width < 600 ? 'column' : 'row'),
    backgroundColor: '#f6efdb',
  },
  info: {
    flex: 1,
  },
  logs: {
    flex: 1,
    borderLeftWidth: 1,
    borderLeftColor: '#f6efdb',
  },

  item: {
    flexDirection: 'row',
  },
  itemSectionText: {
    marginLeft: 10,
    color: '#000000',
    fontSize: 17,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
  },
  itemTitleText: {
    marginLeft: 20,
    color: '#000000',
    fontSize: 17,
    fontWeight: '100',
    backgroundColor: 'transparent',
    ...Platform.select({
      ios: {
        flex: 1,
      },
      android: {
        flex: 1,
      },
    }),
  },
  itemValueText: {
    flex: 1,
    marginLeft: 10,
    marginRight: 10,
    color: '#6b7adc',
    fontSize: 17,
    fontWeight: '300',
    textAlign: 'right',
    backgroundColor: 'transparent',
  },
  itemDivider: {
    position: 'absolute',
    left: 20, bottom: 0, right: 10,
    height: 1,
    backgroundColor: '#6b7adc',
  },

  input: {
    height: 44,
    marginTop: 10,
    marginLeft: 10,
    marginRight: 10,
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#e2d7ba',
    backgroundColor: '#ffffff',
  },
  textInput: {
    marginLeft: 12,
    padding: 0,
    color: '#51585e',
    fontSize: 17,
    fontWeight: '300',
    backgroundColor: 'transparent',
    ...Platform.select({
      web: {
        outline: 'transparent',
      },
    }),
  },

  actionList: {
    width: contentWidth,
    alignSelf: 'center',
  },
  actionButton: {
    width: contentWidth,
    height: 56,
    marginTop: 10,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  actionButtonImage: {
    position: 'absolute',
    top: 0, left: 0,
    width: contentWidth,
    height: 56,
    resizeMode: 'stretch',
  },
  actionButtonText: {
    color: '#ffffff',
    fontSize: 20,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
    zIndex: 1,
  },
  actionActivity: {
    position: 'absolute',
    top: 0, bottom: 0, right: 12,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
  },
  actionActivityIndicator: {},
});

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderScreen);



// WEBPACK FOOTER //
// ./src/order/OrderScreen.js